import { Color, Container, FillGradient, Text, TextStyle } from "pixi.js";
import { IScene, Manager } from "../core/Manager";
import { Reels } from "../reels/Reels";
// import { setSpinResponseDataGlobal } from "../config/GlobalVariableConfig";
import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { isSuperQuickBtnOnGlobal, languageGlobal, RespinIndex, setFsInitIndex, setMaxWinBtnClosedGlobal, waitUntilMaxWinBtnClosed, willBannerAutoProceedGlobal } from "../config/GlobalVariableConfig";
import { spinData } from "../server/getServerResposesFun";
// import { Banner } from "./Banner";
import { BigWin } from "./BigWin";
import { GameScene } from "./GameScene";


import { sound } from "@pixi/sound";
import { Easing, Group, Tween } from "tweedle.js";
import { CharacterComponent } from "../components/character/CharacterComponent";
import { HighlightFramesComponent } from "../components/highlight/HighlightFramesComponent";
import { ReelComponent } from "../components/reels/ReelsComponent";
import { WindMillComonent } from "../components/windmill/WindMillFeatureComponent";
import { WinMeterComponent } from "../components/winmeters/WinMeterComponent";
import { getFontConfig } from "../config/introTextConfig";
import { DisplayComponent } from "../core/displays/DisplayComponent";
import { DisplayComponentFactory } from "../core/displays/DisplayComponentFactory";
import { DisplayObject } from "../core/displays/DisplayObject";
import { reelSpinEmitter } from "../reels/ReelInit";


const tweenGroup: Group = new Group();

const logoPositionLandscape = {
    x: 1490,
    y: 1050,
    scale: 0.95
};
const logoPositionPortrait = {
    x: 1490,
    y: 1050,
    scale: 1
};


declare const window: any;
const translationManager = window.hacksawCasino.Translation;

export class FreeGameScene extends Container implements IScene {

    // Asset bundles
    assetBundles: string[] = ["game-screen", "sound", "intro-screen", "big-win"];

    // Containers
    private game = new Container();
    private reelFrame = new Container();


    private backgroundImageCont = new Container();
    private logo: Spine | null = null;
    // private logo: Sprite | null = null;

    private backgroundSpine: Spine | null = null;
    private reelBack: Spine | null = null;

    private reels: Reels | null = null;
    // private banner: Banner | null = null;
    private bigWin: BigWin | null = null;

    // private backgroundMusic: Sound | null = null;

    private numberOfFS: number;
    private baseGameWin: number;
    private totalFGSessionWin: number; // this is total win including base spin

    private firstSpin: boolean = true;

    private numberOfFSPlayed: number = 0;

    private autoTriggerTimeout: ReturnType<typeof setTimeout>;


    private boundAnimateCharacter: () => void;
    private boundShakeEffect: () => void;

    private pointerDownHandlerFree: () => void;

    constructor(numberOfFS: number, baseGameWin: number) {
        super();
        this.numberOfFS = numberOfFS;
        this.numberOfFSPlayed = 0;
        this.baseGameWin = baseGameWin;


        this.totalFGSessionWin = baseGameWin;

        this.firstSpin = true;


        this.boundAnimateCharacter = this.animateCharacter.bind(this);
        this.boundShakeEffect = this.shakeEffect.bind(this);

        this.pointerDownHandlerFree = this.onBannerPointerDown.bind(this);

        reelSpinEmitter.off('animateCharacter', this.boundAnimateCharacter);
        reelSpinEmitter.off('shakeEffect', this.boundShakeEffect);
        reelSpinEmitter.off('triggerFeature', this.handleFeature, this);

        reelSpinEmitter.on('animateCharacter', this.boundAnimateCharacter);
        reelSpinEmitter.on('shakeEffect', this.boundShakeEffect);
        reelSpinEmitter.on('triggerFeature', this.handleFeature, this);
    }

    override  destroy() {

        reelSpinEmitter.off('animateCharacter', this.boundAnimateCharacter);
        reelSpinEmitter.off('shakeEffect', this.boundShakeEffect);
        reelSpinEmitter.off('triggerFeature', this.handleFeature, this);
        DisplayComponent.unregister(CharacterComponent);
        DisplayComponent.unregister(HighlightFramesComponent);
        DisplayComponent.unregister(ReelComponent);
        DisplayComponent.unregister(WindMillComonent);
        DisplayComponent.unregister(WinMeterComponent);

        this.reels?.destroy(true);
        this.reels = null;
        super.destroy({ children: true, texture: false });
    }

    private handleFeature(callback: () => void) {
        const currentData = spinData.respins[RespinIndex.value];
        if (currentData.type === "fs_windmill_reveal" || currentData.featureData) {
            return DisplayComponent.get(WindMillComonent).startWindMillFeature(callback);
        } else {
            callback();
            return Promise.resolve();
        }
    }

    private shakeEffect() {

        console.log("inside shakeEffect");

        let duration = 250;
        let intensity = 20;

        const original = { x: this.x, y: this.y };
        const offset = { x: 0, y: 0 };

        const tween = new Tween(offset, tweenGroup)
            .to({ x: 0, y: 0 }, duration)
            .onUpdate(() => {
                this.x = original.x + (Math.random() - 0.5) * intensity;
                this.y = original.y + (Math.random() - 0.5) * intensity;
            })
            .onComplete(() => {
                this.x = original.x;
                this.y = original.y;
                tweenGroup.remove(tween);
            })
            .start();
    }


    public async constructorWithAssets(): Promise<void> {

        this.setupBackground();

        this.setupLogo();

        this.reels = new Reels();
        DisplayComponent.register(new DisplayComponentFactory(ReelComponent));
        DisplayComponent.get(ReelComponent).init();
        this.reels = DisplayComponent.get(ReelComponent).getInstance();
        // this.background.addChild(this.reels);
        // this.reels.position.set(-506, -395);
        // this.reels.alpha = 0;

        this.setupReelFrame();

        this.bigWin = new BigWin(Manager.screenwidth, Manager.screenHeight);
        this.bigWin.position.set(Manager.screenwidth / 2, Manager.screenHeight / 2);

        this.addChild(this.bigWin);

        this.setupRetriggerText();

        this.resize(Manager.screenwidth, Manager.screenHeight);


    }

    private callExitFreeGameAuto() {
        //  clearTimeout(this.autoTriggerTimeout);
        this.autoTriggerTimeout = setTimeout(() => {
            clearTimeout(this.autoTriggerTimeout);
            console.log("calling freeGameSceneChnage exitFreeGame pointerdown auto")
            this.exitFreeGame();
        }, 10000); // 10 seconds
    }

    private onBannerPointerDown(): void {
        clearTimeout(this.autoTriggerTimeout);
        console.log("calling freeGameSceneChnage exitFreeGame pointerdown")

        this.exitFreeGame();

        Manager.banner.off('pointerdown', this.pointerDownHandlerFree);

    }

    private setupMeterContainer(): void {
        DisplayComponent.register(new DisplayComponentFactory(WinMeterComponent));
        DisplayComponent.get(WinMeterComponent).init();
        let inst = DisplayComponent.get(WinMeterComponent).getInstance();
        this.game.addChild(inst);
    }

    private animateCharacter(variant: string): void {
        DisplayComponent.get(CharacterComponent).animateCharacter(variant);
        // this.shakeEffect();
    }


    private retriggerText: Text = new Text({});

    private setupRetriggerText() {

        const {
            fontFamily: fontFamilyHeading,
            fontWeight: fontWeightHeading,
            // fontSize: fontSizeHeading,
        } = getFontConfig(languageGlobal, "introHeading");

        console.log("setupRetriggerText", fontFamilyHeading, fontWeightHeading);


        this.retriggerText.label = "retriggerText";

        const fill = new FillGradient(0, 0, 0, 25 * 1 * 12);
        const colors = ["#fff08d", "#ffca3b", "#eb8810"].map((color) => Color.shared.setValue(color).toNumber());

        colors.forEach((number, index) => {
            const ratio = index / colors.length;

            fill.addColorStop(ratio, number);
        });

        this.retriggerText.style = new TextStyle({
            fontFamily: fontFamilyHeading,
            fill: { fill },
            fontWeight: fontWeightHeading,
            fontSize: 140,
            stroke: {
                color: "#000000",
                width: 6,
                join: "round"
            },
            dropShadow:
            {
                blur: 8,
                color: "#000000",
                distance: 0,
                alpha: 1
            },
            letterSpacing: 2,
            align: "center",
            // breakWords: true,
            // wordWrap: true,
            // wordWrapWidth: 850,

        });

        this.retriggerText.anchor.set(0.5);
        this.retriggerText.position.set(1500, 1500);

        // const spacing = 20;
        this.game.addChild(this.retriggerText);

        this.retriggerText.text = "";
        this.retriggerText.scale = 0;
    }

    private appearTextRetriggerText(numOfRespins: number): Promise<void> {

        return new Promise<void>(async (resolve) => {
            let timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
            // this.retriggerText.text = `+${numOfRespins} FREE SPINS`
            const targetScale = Math.min(950 / 1000, 1);

            // 1. Initial State: Small and dim
            this.retriggerText.scale.set(targetScale * 0.8);
            this.retriggerText.alpha = 0;
            this.retriggerText.tint = 0x666666;

            // Scramlble Logic
            // const scrambleData = { value: 0 };

            // const scrambleTween = new Tween(scrambleData, tweenGroup)
            //     .to({ value: numOfRespins }, 500) // Duration of scramble
            //     .easing(Easing.Quadratic.Out)
            //     .onUpdate(() => {
            //         const displayNum = Math.floor(scrambleData.value);
            //         this.retriggerText.text = translationManager.game('banner_retrigger_desc', null, {
            //             'freegamenumber': `+${displayNum}`
            //         });

            //         // Add a "jitter" effect during update
            //         this.retriggerText.x = 1500 + (Math.random() - 0.5) * 10;
            //         this.retriggerText.y = 1500 + (Math.random() - 0.5) * 10;
            //     });

            // 3. The "Explosion" on Complete
            // scrambleTween.onComplete(() => {
            //     // Ensure final text is correct
            this.retriggerText.text = translationManager.game('banner_retrigger_desc', null, {
                'freegamenumber': `+${numOfRespins}`
            });
            //     });

            //     // Visual "Pop"
            this.retriggerText.tint = 0xFFFFFF; // Flash to bright
            //     this.retriggerText.position.set(1500, 1500); // Reset jitter

            sound.play("fsSpin_awarded", { volume: 0.7, speed: timeScale });

            new Tween(this.retriggerText.scale, tweenGroup)
                .to({ x: targetScale * 1.3, y: targetScale * 1.3 }, 100) // Overshoot
                .yoyo(true)
                .repeat(1)
                .easing(Easing.Back.Out)
                .start();

            // Screen shake effect
            this.shakeText(this.retriggerText, 20, 300);
            // });

            // Start the intro fade + scramble
            new Tween(this.retriggerText)
                .to({ alpha: 1 }, 200)
                .start();

            // scrambleTween.start();

            // Wait for the scramble + display duration
            await new Promise(resolve => setTimeout(resolve, isSuperQuickBtnOnGlobal ? 500 : 1000));

            // 4. Outro: Squeeze away
            const tweenScaleUp = new Tween(this.retriggerText.scale, tweenGroup)
                .to({ x: targetScale * 2, y: targetScale * 2 }, 300)
                .easing(Easing.Exponential.In)
                .onComplete(() => {
                    tweenGroup.remove(tweenScaleUp);
                    this.retriggerText.text = "";
                    this.retriggerText.scale = 0;
                    resolve();
                })
                .start();

            await new Promise(resolve => setTimeout(resolve, isSuperQuickBtnOnGlobal ? 500 : 1000));

            new Tween(this.retriggerText)
                .to({ alpha: 0 }, 200)
                .start();
        });
    }

    private shakeText(target: any, intensity: number, duration: number) {
        const startX = target.x;
        const startY = target.y;
        let elapsed = 0;
        const interval = 16; // roughly 60fps

        const shakeInterval = setInterval(() => {
            elapsed += interval;
            if (elapsed >= duration) {
                target.position.set(startX, startY);
                clearInterval(shakeInterval);
            } else {
                target.x = startX + (Math.random() - 0.5) * intensity;
                target.y = startY + (Math.random() - 0.5) * intensity;
            }
        }, interval);
    }

    public async freeSpinPlay() {


        // Manager.banner.bgContainer.once('pointerdown', () => {

        //     clearTimeout(this.autoTriggerTimeout);
        //     console.log("calling freeGameSceneChnage exitFreeGame pointerdown")

        //     this.exitFreeGame();
        // });


        // this.updateMultiplier(0);
        // this.updateSurgeMeter(0);


        // casinoChannel.publish('featureRoundStarted', { uistate: 'freespins', gameMode: 'fs_' });
        // Manager.casinoChannelHandler.reportFeatureRoundStarted();

        console.log("casinoChannel-featureRoundStarted")
        // casinoChannel.publish('updateFeatureCounter', { counterValue: 111 });
        // casinoChannel.publish('updateFeatureTotalWin', { totalWinAmount: `${(99)}` });

        // casinoChannel.publish('updateFeatureCounter', { counterValue: this.numberOfFS });
        // Manager.casinoChannelHandler.reportUpdateFeatureCounter(this.numberOfFS)

        console.log("this.numberOfFS", this.numberOfFS);


        console.log("casinoChannel-updateFeatureCounter")

        // this.ui?.resetWinValue();
        setFsInitIndex(RespinIndex.value);
        const fsRevealIndexes = spinData.respins
            .map((respin, index) => (respin.type === "fs_reveal" ? index : -1))
            .filter(index => index !== -1);

        console.log("fsRevealIndexes", fsRevealIndexes);

        let freeGameTrigger = 1;
        let winAmount: number;
        let accumulatedsWinAmount: number;

        while (freeGameTrigger != -1 && freeGameTrigger != -2) {

            // this.ui.setFreeGameCounter(totalFreeGame, totalFreeGame - freeSpinRemaining + 1);
            //update counter here


            Manager.casinoChannelHandler.reportFeatureRoundStarted();


            if (this.firstSpin) // first time counter appear
            {
                this.firstSpin = false;
                Manager.casinoChannelHandler.reportUpdateFeatureCounter(this.numberOfFS);
                Manager.casinoChannelHandler.reportUpdateFeatureTotalWin((this.baseGameWin * 100).toFixed(0));
                await new Promise(resolve => setTimeout(resolve, 500));
            }

            this.numberOfFS = this.numberOfFS - 1;
            if (this.numberOfFS >= 0) {
                Manager.casinoChannelHandler.reportUpdateFeatureCounter(this.numberOfFS);
                this.numberOfFSPlayed = this.numberOfFSPlayed + 1;
            }

            [freeGameTrigger, winAmount, accumulatedsWinAmount] = await this.spinReel();

            console.log("Freegame while loop", freeGameTrigger, winAmount, RespinIndex.value);

            let prevRes = RespinIndex.value - 1;
            if (prevRes > 0 && spinData.respins[prevRes].type === "fs_windmill_reveal" && spinData.respins[RespinIndex.value].type === "max_win_reached") {
                console.log("dont play big win here");
            } else if (winAmount > 0 && freeGameTrigger != -1) {
                await this.bigWin.bigWinFunction(winAmount);
            }



            if (freeGameTrigger > 0) {

                console.log("RespinIndex.value", RespinIndex.value);
                await this.reels?.processWinFeatureSymbol(RespinIndex.value);

                this.numberOfFS = this.numberOfFS + freeGameTrigger;

                Manager.casinoChannelHandler.reportUpdateFeatureCounter(this.numberOfFS);

                await this.appearTextRetriggerText(freeGameTrigger)


            }

            Manager.casinoChannelHandler.reportFeatureRoundCompleted((winAmount * 100).toFixed(0));

            const featureWinCentsNum = Math.floor(winAmount * 100);
            console.log("reportUpdateFeatureTotalWin", featureWinCentsNum);

            Manager.casinoChannelHandler.reportUpdateFeatureTotalWin((accumulatedsWinAmount * 100).toFixed(0));

            if (winAmount > 0) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }

            if (freeGameTrigger == -1 || freeGameTrigger == -2) {
                this.totalFGSessionWin = accumulatedsWinAmount;
            }

        }

        console.log("Freegame while loop exit");

        if (Manager.banner) {

            if (freeGameTrigger === -2) { // max win reached
                setMaxWinBtnClosedGlobal(false);
                Manager.casinoChannelHandler.reportMaxWin();

                // wait here till isMaxWinBtnClosedGlobal == true;

                await waitUntilMaxWinBtnClosed();

            }

            DisplayComponent.get(WinMeterComponent).getInstance().resetMultipliers();
            Manager.casinoChannelHandler.reportFeatureExit();
            await Manager.banner.appearFreeGameOutroBanner(this.totalFGSessionWin, this.numberOfFSPlayed);

            if (willBannerAutoProceedGlobal) {
                this.callExitFreeGameAuto();
            }

            console.log("appearFreeGameOutroBanner");

            const game = new GameScene();
            await Manager.changeScene(game, false);

            Manager.banner.on('pointerdown', this.pointerDownHandlerFree);


        }


    }

    private async exitFreeGame() {
        // Manager.casinoChannelHandler.reportFeatureExit();

        // currentBackgorundMusic.stop();

        console.log("casinoChannel-featureExit");

        // this.backgroundMusic?.stop();
        await Manager.banner?.disappearBanner();



        // reportGameRoundCompleted();
        Manager.casinoChannelHandler.reportGameRoundCompleted();

    }

    private async spinReel(): Promise<[number, number, number]> {

        let freeGameTrigger = 0;
        let winAmount = 0;
        let accumulatedsWinAmount = 0;

        if (this.reels) {

            [freeGameTrigger, winAmount, accumulatedsWinAmount] = await this.reels.startPlay("FREEGAME");

            console.log("freeGameTrigger", freeGameTrigger);
            console.log("winAmount", winAmount);

        }

        return [freeGameTrigger, winAmount, accumulatedsWinAmount];

    }


    private setupBackground(): void {

        // this.backgroundImageCont.addChild(Sprite.from('backgroundFree'));
        this.addChild(this.backgroundImageCont);


        // this.background.addChild(Sprite.from('baseReels'));

        this.backgroundSpine = Spine.from({
            skeleton: "freeBackgroundSkel",
            atlas: "freeBackgroundAtlas",
            // skeleton: "freeBackgroundSkel",
            // atlas: "freeBackgroundAtlas",
        });

        this.backgroundSpine.position.set(3000 / 2, 3000 / 2);

        // spineSymbol.scale=0.1;

        this.backgroundImageCont.addChild(this.backgroundSpine);




        this.addChild(this.game);
    }

    private setupLogo(): void {

        this.logo = Spine.from({
            skeleton: "logoSkel",
            atlas: "logoAtlas",
        });
        // this.logo = Sprite.from('logoStatic');
        this.logo.alpha = 0;

        this.game.addChild(this.logo);
        this.logo.state.setAnimation(0, "animation", true);

        // const animations = this.logo.skeleton.data.animations.map(anim => anim.name);
        // console.log("Available animations:", animations);

    }

    private setupCharacter(): void {
        DisplayComponent.register(new DisplayComponentFactory(CharacterComponent));
        DisplayComponent.get(CharacterComponent).init();
        let inst = DisplayComponent.get(CharacterComponent).getInstance();
        this.game.addChild(inst);
    }

    private setupHighlightFrames(): void {
        DisplayComponent.register(new DisplayComponentFactory(HighlightFramesComponent));
        DisplayComponent.get(HighlightFramesComponent).init();
        let inst = DisplayComponent.get(HighlightFramesComponent).getInstance();
        this.reelFrame.addChild(inst);
    }

    private async setupReelFrame(): Promise<void> {


        // const reelBack = Sprite.from("reelBackFree");
        this.reelBack = Spine.from({
            skeleton: "reelFrameFgSkel",
            atlas: "reelFrameFgAtlas",
        });
        // reelBack.anchor = 0.5;
        //reelBack.state.setAnimation(0, "reel_idle", true);
        this.reelBack.position.set(-42, 245);
        this.reelFrame.label = "fg_reelframe";
        this.reelFrame.addChild(this.reelBack);

        this.reels.position.set(-473, -124);
        this.setupHighlightFrames();
        this.reelFrame.addChild(this.reels);

        // this.reelFrame.eventMode = "static"; // prevents the character from receiving clicks when it's behind the reels (in portrait mode)

        this.game.addChild(this.reelFrame);


        this.setupCharacter();
        this.setupMeterContainer();

        this.game.addChild(this.logo);
        this.logo.state.setAnimation(0, "animation", true);

        this.backgroundSpine.state.setAnimation(0, "animation", true); // idle ANIMATION

        this.reelBack.state.setAnimation(0, "animation", true);

        // reelBackSlidesSpine.alpha = 1;
        // reelBackSlidesSpine.state.setAnimation(0, "animation", true);

        // console.log(doAnimate);
        // doAnimate = false;


        this.logo.alpha = 1;
        this.reelFrame.alpha = 1;

        this.backgroundImageCont.alpha = 1;
        this.backgroundSpine.alpha = 1;




    }




    public update(): void {
        tweenGroup.update();

        this.reels?.update();
        // this.banner?.update();
        this.bigWin?.update();
    }

    public resize(screenWidth: number, screenHeight: number): void {

        // this.screenWidth = screenWidth;
        // this.screenHeight = screenHeight;

        let scale: number;

        let bgScale;
        const BG_SCALE_FACTOR = Math.max(screenWidth / 3000, screenHeight / 3000);


        if (screenWidth > screenHeight) {

            scale = 1 * Math.min(screenWidth / 1920, screenHeight / 1080);
            bgScale = Math.max(scale, BG_SCALE_FACTOR);

            this.game.scale.set(scale, scale);

            const xPos = (3000 * scale - screenWidth) / 2;
            const yPos = ((3000 + 0) * scale - screenHeight) / 2;

            // this.y = -200 * scale;

            this.game.x = -xPos;
            this.game.y = -yPos;

            this.reelFrame.scale = 1;
            this.reelFrame.position.set(1538, 1275);

            this.logo.scale = logoPositionLandscape.scale;
            this.logo.position.set(logoPositionLandscape.x, logoPositionLandscape.y);

            // this.winMult.scale = 1;
            // this.winMult.position.set(760, 1500);



            this.game.addChild(this.retriggerText);

            this.backgroundImageCont.scale.set(bgScale, bgScale)
            const bgXPos = (3000 * bgScale - screenWidth) / 2;
            const bgYPos = (3000 * bgScale - screenHeight) / 2;
            this.backgroundImageCont.position.set(-bgXPos, -bgYPos);



        }
        else {


            scale = 1 * Math.min(screenWidth / 1080, screenHeight / 1920);
            bgScale = Math.max(scale, BG_SCALE_FACTOR);

            this.game.scale.set(scale, scale);

            const xPos = (3000 * scale - screenWidth) / 2;
            const yPos = ((3000 + 0) * scale - screenHeight) / 2;

            // this.y = -300 * scale;

            this.game.x = -xPos;
            this.game.y = -yPos;

            this.reelFrame.scale = 1;
            this.reelFrame.position.set(1538, 1275);



            this.game.addChild(this.retriggerText);

            this.logo.scale = logoPositionPortrait.scale;
            this.logo.position.set(logoPositionPortrait.x, logoPositionPortrait.y);




            this.backgroundImageCont.scale.set(bgScale, bgScale)
            const bgXPos = (3000 * bgScale - screenWidth) / 2;
            const bgYPos = (3000 * bgScale - screenHeight) / 2;
            this.backgroundImageCont.position.set(-bgXPos, -bgYPos);



        }

        this.game.children.forEach(element => {
            if (element instanceof DisplayObject) {
                element.setPositionResize(Manager.Orientation);
            }
        });

        this.bigWin?.scale.set(scale, scale);
        this.bigWin?.position.set(screenWidth / 2, (screenHeight / 2) - 50 * scale);
        this.bigWin?.resize(screenWidth, screenHeight);

        // this.banner?.resize(screenWidth, screenHeight);

    }


}
